// extracted by mini-css-extract-plugin
export default {"tarjetas":"Tarjetas_tarjetas__VHSuv","animes":"Tarjetas_animes__rwucz","lista":"Tarjetas_lista__WScua","animes_contenido":"Tarjetas_animes_contenido__W6Ubc"};